export type TenantDomainContext = {
  isTenantDomain: boolean;
  tenantHint: string | null;
};

const platformHosts = new Set(["raqoz.com", "www.raqoz.com", "app.raqoz.com"]);

export function normalizeTenantIdentity(value: string | null | undefined) {
  return String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "");
}

export function resolveTenantDomain(hostname = window.location.hostname): TenantDomainContext {
  const host = hostname.toLowerCase().split(":")[0];
  if (!host.endsWith(".raqoz.com") || platformHosts.has(host)) return { isTenantDomain: false, tenantHint: null };
  const tenantHint = host.slice(0, -".raqoz.com".length).split(".")[0];
  return tenantHint ? { isTenantDomain: true, tenantHint } : { isTenantDomain: false, tenantHint: null };
}

export function tenantDomainLabel(tenantHint: string | null) {
  if (!tenantHint) return null;
  return tenantHint.replace(/[-_]+/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
}
